import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { Data } from '../Data';
import ToolTip from 'react-tooltip-lite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PasswordChecklist from "react-password-checklist";

export class Register extends Component {
    constructor(props) {
        super(props);
        this.dataService = new Data();
        this.postRegister = this.postRegister.bind(this);      
		this.buildQuestionOptions = this.buildQuestionOptions.bind(this);		

        this.state = {
            username: '',
            password: '',
            confirmedpassword: '',
            email: '',
			confirmedemail: '',
			question1:'',
			answer1: '',
			question2:'',
			answer2: '',
			question3: '',
			answer3: '',
            questions: [],
            submitted: false,
            message: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.verifySsnIDExists();
    }

    verifySsnIDExists() {
        const ssnid = sessionStorage.getItem('SsnId');
        if (!ssnid) {
            window.location = '/login'
        }
    }

    handleChange(e) {
        console.log("type:" + e)
            const { name, value } = e.target;
            this.setState({ [name]: value });
    }

    postRegister(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        if ((this.state.password === this.state.confirmedpassword) &&
            (this.state.email === this.state.confirmedemail)) {            
            const { username, password, email, answer1, answer2, answer3, question1, question2, question3 } = this.state;
            if (username && password && email && answer1 && answer2 && answer3 && question1 && question2 && question3) {
                this.dataService.postRegister(username, password, email, answer1, answer2, answer3, question1, question2, question3)
                    .catch((msg) => {
                        const text = msg.message;
                        this.setState({ message: text });
                    });
            }
        }
    }
	
	buildQuestionOptions() {
		if (this.state.questions.length === 0) {
		  this.dataService.getQuestions().then((data) => {
			console.log('data');
              console.log(data.questions);
              this.setState({
                  questions: data.questions,
                  question1: data.questions[0].questionid,
                  question2: data.questions[1].questionid,
                  question3: data.questions[2].questionid
              });
		  });
		}

		var questionOptions = [];
        for (let i = 0; i < this.state.questions.length; i++) {
            questionOptions.push(<option key={this.state.questions[i].questionid} value={this.state.questions[i].questionid}>{this.state.questions[i].questionid + ' - ' + this.state.questions[i].question}</option>)
		}
		return (questionOptions);
    }

    render() {
        const { username, password, confirmedpassword, email, confirmedemail, answer1, answer2, answer3, question1, question2, question3, submitted, message } = this.state;
        return (
            <div>
                <h4>Register New Member</h4>
                <form name="form" onSubmit={this.postRegister}>
                    <div className='login-form-container'>
                        <label className='login-form-label'>USERNAME</label>
                        <ToolTip
                            content={(
                                <div>
                                    <p className="tip-heading"><strong>Username Criteria:</strong> Must be at least four (4)<br />
                                        characters in length and cannot contain<br/> consecutive white spaces.</p>
                                </div>
                            )}
                            direction="right"
                            tagName="span"
                            className="target"
                            tipContentClassName="tip-container">
                            <FontAwesomeIcon icon='info-circle' />
                        </ToolTip>
                        <input
                            placeholder="Username"
                            type="text"
                            className={'form-control' + (submitted && !username ? ' has-error' : '') + ' login-form-text'}
                            name="username"
                            value={username}
                            onChange={this.handleChange}
                            title="User name text box"
                        />
                        {submitted && !username &&
                            <div className="help-block">Username is required</div>
                        }

                        <label className='login-form-label'>PASSWORD</label>
                        
                        <input
                            placeholder="Password"
                            type="password"
                            className={"form-control" + (submitted && !password ? ' has-error' : '') + ' login-form-text'}
                            name="password"
                            value={password}
                            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~!@#$%^&*()_+-={}\|;:',<.>/])[A-Za-z\d`~!@#$%^&*()_+-={}\|;:',<.>/]{8,}$"
                            onChange={this.handleChange}
                            title="Password text box"
                        />
                        
                        {submitted && !password &&
                            <div className="help-block">Password is required</div>
                        }
                        
                        <label className='login-form-label'>CONFIRM PASSWORD</label>
                        <input
                            placeholder="Confirm Password"
                            type="password"
                            className={"form-control" + (submitted && !confirmedpassword ? ' has-error' : '') + ' login-form-text'}
                            name="confirmedpassword"
                            value={confirmedpassword}
                            onChange={this.handleChange}
                            title="Confirm password text box"
                        />
                        {submitted && !confirmedpassword &&
                            <div className="help-block">Confirm Password is required</div>
                        }
                        {submitted && (password !== confirmedpassword) &&
                            <div className="help-block">Password and Confirm Password are not the same</div>
                        }
                        <PasswordChecklist
                            rules={["length", "specialChar", "number", "capital", "match"]}
                            minLength={8}
                            value={password}
                            valueAgain={confirmedpassword}
                            className={"tip-container"}
                            iconSize={12}
                        />
                        <label className='login-form-label'>EMAIL</label>
                        <input
                            placeholder="Email"
                            type="text"
                            className={"form-control" + (submitted && !email ? ' has-error' : '') + ' login-form-text'}
                            name="email"
                            value={email}
                            pattern="^.+@[^\.].*\.[a-z]{2,}$"
                            title="name@mydomain.com"
                            onChange={this.handleChange}
                        />
                    
                        {submitted && !email &&
                            <div className="help-block">Email is required</div>
                        }
                        <label className='login-form-label'>CONFIRM EMAIL</label>
                        <input
                            placeholder="Confirm Email"
                            type="text"
                            className={"form-control" + (submitted && !confirmedemail ? ' has-error' : '') + ' login-form-text'}
                            name="confirmedemail"
                            value={confirmedemail}
                            pattern="^.+@[^\.].*\.[a-z]{2,}$"
                            title="name@mydomain.com"
                            onChange={this.handleChange}
                        />
                        {submitted && !confirmedemail &&
                            <div className="help-block">Confirm Email is required</div>
                        }
                        {submitted && (email !== confirmedemail) &&
                            <div className="help-block">Email and confirm email are not the same</div>
                        }
                    </div>
                    <hr />
                    <p>Security Questions <br /><span className="login-form-text-xsmall">Select three (3) different questions</span></p>
                    <div className='login-form-container'>
                        <label className='login-form-label'>QUESTION 1</label>
                        <Input
                            type="select"
                            className="form-control login-form-text login-form-text-small"
                            name="question1"
                            value={question1}
                            onChange={this.handleChange}
                            title="Security question drop down list 1"
                        >
						    {this.buildQuestionOptions()}
					    </Input>
                        <input
                            placeholder="Your Answer"
                            type="text"
                            className={"form-control" + (submitted && !answer1 ? ' has-error' : '') + ' login-form-text'}
                            name="answer1"
                            value={answer1}
                            onChange={this.handleChange}
                            title="Security answer text box"
                        />
                        {submitted && !answer1 &&
                            <div className="help-block">Anwser to question 1 is required</div>
                        }
                        <label className='login-form-label'>QUESTION 2</label>
                        <Input
                            type="select"
                            className="form-control login-form-text login-form-text-small"
                            name="question2"
                            value={question2}
                            onChange={this.handleChange}
                            title="Security question drop down list 2"
                        >
						    {this.buildQuestionOptions()}
					    </Input>
                        <input
                            placeholder="Your Answer"
                            type="text"
                            className={"form-control" + (submitted && !answer2 ? ' has-error' : '') + ' login-form-text'}
                            name="answer2"
                            value={answer2}
                            onChange={this.handleChange}
                            title="Security answer text box"
                        />
                        {submitted && !answer2 &&
                            <div className="help-block">Anwser to question 2 is required</div>
                        }
                        {(question1===question2) &&
                            <div className="help-block">Questions 1 and 2 are the same. Select a different question 2</div>
                        }
                        <label className='login-form-label'>QUESTION 3</label>
                        <Input
                            type="select"
                            className="form-control login-form-text login-form-text-small"
                            name="question3"
                            value={question3}
                            onChange={this.handleChange}
                            title="Security question drop down list 3"
                        >
						    {this.buildQuestionOptions()}
					    </Input>
                        <input
                            placeholder="Your Answer"
                            type="text"
                            className={"form-control" + (submitted && !answer3 ? ' has-error' : '') + ' login-form-text'}
                            name="answer3" value={answer3}
                            onChange={this.handleChange}
                            title="Security answer text box"
                        />
                        {submitted && !answer3 &&
                            <div className="help-block">Anwser to question 3 is required</div>
                        }
                        {(question1===question3) && 
                            <div className="help-block">Questions 1 and 3 are the same.  Select a different question 3</div>
                        }
                        {(question2 === question3) &&
                            <div className="help-block">Questions 2 and 3 are the same.  Select a different question 3</div>
                        }
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary login-button" title="Button to register new user">Register</button>
                        <a href="/Login" title="Link to cancel registration">Cancel</a>
                    </div>
                </form>
                {message && <div className="help-block">{message}</div>}
            </div>
        );
    }
}
